// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildRegistrationPayload} from '../../../product/shared/services/build-registration-payload';
import {getRegistrationResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const updateRegistrationResults = isInitialLoad =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());
        const facetsReg = getState().registrationReview.facets;

        const registrationPayload = buildRegistrationPayload(facetsReg, '', '');

        try {

            const registrationResults = await getRegistrationResults(registrationPayload);

            dispatch({
                data: registrationResults,
                type: actions.UPDATE_REGISTRATION_RESULTS
            });

            if (isInitialLoad) {

                readExcelLayouts('transfers')(dispatch);

            }

            if (!getState().exportToExcel.selectedExcelLayout.registrations.name) {

                readExcelLayouts('registrations')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetRegistrationReviewFacets = allowedDealers =>

    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.RESET_REGISTRATION_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/product/registration-review/action-creators/registration.js